<div class="search-stored-search-menu">
  @if (showStoredSearchPanel) {
    <app-stored-search-menu-panel
      (closeStoredSearchPanel)="toggleStoredSearchPanel()"
      [fsi]="fsi"
      [searchContainer]="searchContainer"
    ></app-stored-search-menu-panel>
  }

  <div class="search-stored-search-menu__text-container">
    <mat-icon [class.text-blue]="searchContainer.storedSearch.curStoredSearchId">
      visibility
    </mat-icon>

    @if (!searchContainer.storedSearch.curStoredSearchId) {
      <span class="search-storedSearch-menu__no-storedSearch-selected-text">
        {{ 'TRANS__FOCUS__INFO_NO_FOCUS_SELECTED' | translate }}
      </span>
    }

    @if (searchContainer.storedSearch.curStoredSearchId && searchContainer.storedSearch.curStoredSearch.stored_search.name) {
      <div class="search-storedSearch-menu__text-container">
        <span class="search-storedSearch-menu__text">
          {{searchContainer.storedSearch.curStoredSearch.stored_search.name}}
        </span>

        <a
          class="color-white text-blue-hover"
          (click)="deselectStoredSearch()"
        >
          <mat-icon>
            close
          </mat-icon>
        </a>
      </div>
    }
  </div>

  <div class="search-storedSearch-menu__split-button">
    <button
      class="search-storedSearch-menu__set-storedSearch-button"
      (click)="toggleStoredSearchPanel()"
      [ngClass]="{'active': showStoredSearchPanel,
                  'bg-blue': !showStoredSearchPanel && searchContainer.storedSearch.curStoredSearchId && searchContainer.storedSearch.curStoredSearch.stored_search.stored && hasChanges()}"
    >
      {{'TRANS__FOCUS__BUTTON_FOCUS' | translate}}

      <mat-icon>
        expand_more
      </mat-icon>
    </button>

    <mat-menu
      #leaveStoredSearch="matMenu"
      class="leave-storedSearch-menu removePaddingInMatMenu"
      (closed)="storedSearchButtonDropdown = false;"
      xPosition="before"
    >
      <button
        (click)="deselectStoredSearch()"
        mat-button
        class="text-blue-hover"
        [disabled]="!searchContainer.storedSearch.curStoredSearchId"
      >
        {{'TRANS__FOCUS__BUTTON_LEAVE_FOCUS' | translate}}
      </button>
    </mat-menu>
  </div>
</div>
